<template>
    <header class="sticky top-0 bg-theme-surface shadow-sm p-3 sm:p-4 flex justify-between items-center border-b border-theme-border z-0">
      <div class="flex items-center space-x-4">
        <!-- Mobile menu button -->
        <button @click="toggleSidebar" class="md:hidden text-theme-text2 hover:text-theme-text">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
  
        <!-- Page title -->
        <h1 class="text-lg sm:text-xl font-semibold text-theme-text capitalize">
          {{ formattedRouteName }}
        </h1>
      </div>
  
      <!-- User info and logout -->
      <div class="flex items-center space-x-3 sm:space-x-4">
        <span class="text-sm sm:text-base text-theme-text2">
          {{ authStore.user ? `Welcome, ${authStore.user.first_name}` : 'Welcome back' }}
        </span>
        <button 
          v-if="authStore.user" 
          @click="logout" 
          class="text-sm sm:text-base text-red-500 hover:text-red-700 transition-colors flex items-center"
        >
          <svg class="w-4 h-4 sm:w-5 sm:h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Logout
        </button>
      </div>
    </header>
  </template>
  
  <script setup>
  import { computed, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useAuthStore } from '../store/auth';
  import { useLogger } from '@/composables/useLogger';

  const logger = useLogger('Header');
  
  const route = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();
  
  // Ensure header updates correctly when navigating
  const formattedRouteName = computed(() => {
    return route.name ? route.name.replace(/([A-Z])/g, ' $1').trim() : 'Dashboard';
  });
  
  // Watch for route changes and log them (for debugging)
  watch(() => route.name, (newName) => {
    logger.debug('Route changed', { route: newName });
  });
  
  // Sidebar toggle event
  const toggleSidebar = () => {
    const event = new CustomEvent('toggle-sidebar');
    window.dispatchEvent(event);
  };
  
  // Logout functionality
  const logout = () => {
    authStore.logout();
    router.push('/login');
  };
  </script>
  